import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';
import HttpService from '../../services/httpService'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { connect } from "react-redux";
import { setUserDetails } from '../../redux/actions/userAction'
import Paper from '@material-ui/core/Paper';
import '../../App.css'
import moment from 'moment';
import {
  AppBar,
  Grid,
  TextField,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
  Button,
  useTheme,
  IconButton,
  TableFooter,
} from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
const useStyles1 = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		marginLeft: theme.spacing(2.5),
	},
}));


const useStyles = makeStyles((theme) => ({
  root: {
		flexShrink: 0,
		marginLeft: theme.spacing(2.5),
	},
  table: {
    width: "fit-content",
    margin: '10px'
    // width: "auto", /* or specify a fixed width */
    // min-width: '100%', /* Set a minimum width */
  },
  tablecontainer: {
    display: "flex",
    margin: "25px",
  },
  tableform: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 500,
  },
  clickableTableCell: {
    cursor: "pointer",
    textDecoration: "underline",
    color: "blue",
  },
  normalTableCell: {
    color: "black",
    "&:hover": {
      cursor: "pointer",
      color: "blue", // you can change the color when hovering here
      textDecoration: "underline",
    },
  },
  tableCell: {
    color: "blue",
    cursor: "pointer",
    textDecoration: "underline",

    // Changing color, cursor and textDecoration  hovering
    // "&:hover": {
    // 	cursor: "pointer",
    // 	color: "blue", // you can change the color when hovering here
    // 	textDecoration: "underline",
    // },
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  narrowTab: {
    minWidth: "fit-content", // Adjust the width as needed
    // width:"fit-content",
    width: 65,
  },
  margin: {
    margin: theme.spacing(1),
  },
  activeButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
  },
  redButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
    margin: "10px"
  },
  normalButton:{
    margin: "10px"
  },
  cardDialog: {
    minWidth: "80%",
    cursor: 'default'
  },
  autoComplete: {
    width: "200px",
  },
  searchField: {
    marginTop: "20px",
    width: "800px",
  },
  viewIssueDialog:{
    minWidth: "80%"
  },
  imageList: {
    width: 500,
    // height: 450,
  },
  dialogMargin:{
    margin: "10px",
  },
  actionBar:{ display: "flex", justifyContent: "center", gap: "10px" },
  iconHover:{
  transition: "filter 0.3s ease",
  filter: "brightness(1.3)"
  },
  reassign:{
    minWidth: "500px",
    // minHeight: "300px",
  },
  reassignAutocomplete:{
    margin: "20px",
  },
  editDialogue:{
    minWidth: "600px",
    cursor: 'default'
  },
  dateSize:{
    width: "50%"
  },
  handOnHover:{
    cursor: "pointer"
  },
  remarks:{
    border: '1px solid black'
  },
  iconDisabledColor:{
    color: 'rgb(255, 255, 255)'
  },
  submitButton: {
    backgroundColor: '#F47E46',  // Decorpot Orange
    color: 'white',            // White text
    '&:hover': {
      backgroundColor: '#E0663D', // Darker Orange on hover
    },
},
downloadButton: {
  backgroundColor: '#355025',   // Dark Blue
  color: '#FFF2EB',             // White text
  '&:hover': {
    backgroundColor: '#4A6641', // Derived lighter Dark Blue
  },
},
clearButton: {
  backgroundColor: '#FFF2EB',   // Light Beige
  color: '#1C375D',             // Decorpot Orange text
  '&:hover': {
      backgroundColor: '#EF3F32', // Light Pink on hover
      color: '#FFF2EB'
  },
},
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#3F51B5",
    color: "#FFF",
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function TablePaginationActions(props) {
	const classes = useStyles();
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<div className={classes.root}>
			<IconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label="first page"
			>
				{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
			</IconButton>
			<IconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label="previous page"
			>
				{theme.direction === "rtl" ? (
					<KeyboardArrowRight />
				) : (
					<KeyboardArrowLeft />
				)}
			</IconButton>
			<IconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page"
			>
				{theme.direction === "rtl" ? (
					<KeyboardArrowLeft />
				) : (
					<KeyboardArrowRight />
				)}
			</IconButton>
			<IconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page"
			>
				{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
			</IconButton>
		</div>
	);
}

TablePaginationActions.propTypes = {
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
};

const TeamUserLogs = (props) => {
  const classes = useStyles1();

  const [rawData, setRawData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reRender, setReRender] = useState(true);
  const csvButtonRef = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRowCount, setTotalRowCount] = useState(0);

  const headers = [
    { key: "sNo", label: "S No" },
    { key: "str", label: "Logs" },
  ]
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  // Function to handle change in rows per page
  const handleChangeRowsPerPage = (event) => {
    if (event.target.value === "All"){
      setRowsPerPage (parseInt(totalRowCount,10))
    }else{
      setRowsPerPage(parseInt(event.target.value, 10));
    }
		setPage(0);
  }


  // const handleDateFilter = () => {
  //   setReRender(!reRender)
  // };

  // const clearFilterDate = () => {
  //   setStartDate("");
  //   setEndDate("");
  //   setReRender(!reRender)
  // };

  const getDataOnPageLoading = async ()=>{
    const result = await HttpService.getAllUserlogs(startDate,endDate, page, rowsPerPage);
    const userLogCount = await HttpService.getAllUserLogCount();
    // console.log(result.data)
    setRawData(result.data)
    setTotalRowCount(userLogCount.data)

    let logs =[]
    let sNo=1;
    result.data.forEach((el) => {
      let str = `Changes For ${el?.user?.name}  \n`;
      if (el.user) {
          // const userName = el?.user?.name;
          if (el.isActive === false) {
              str+=`user was deactivated \n`;
          }
          if (el.isActive === true) {
              str+=`user was activated \n`;
          }
      }
  
      if (el.deleted === true) {
          str+=`user was deleted \n`;
      }

      if (el.departmentId) {
          str+=`Department is changed to ${el?.departmentId?.name} \n`;
      }
      if (el.teamId) {
          str+=`Team is changed to ${el?.teamId?.name} \n`;
      }
      if (el.assistantManagerId) {
          str+=`Assistant Manager is changed to ${el?.assistantManagerId?.name} \n`;
      }
      if (el.mobile) {
          // console.log('mobile number found')
          str+=`Mobile Number is changed to ${el?.mobile} \n`;
      }
  
      // Add additional conditions for other fields like roles, locationId, etc., if needed.
      if (el.roles && el.roles.length > 0) {
          str+=`Roles updated to: ${el.roles.map(el=>el.name).join(", ")} \n`;
      }
  
      if (el.locationId && el.locationId.length > 0) {
          str+=`Location updated to: ${el.locationId.map(el=>el.name).join(", ")} \n`;
      }
  
      if (el.experienceCenterId && el.experienceCenterId.length > 0) {
          str+=`Experience Center updated to: ${el.experienceCenterId.map(el=>el.name).join(", ")} \n`;
      }

      str = str.slice(0, -2);
      str+= ` on ${moment(el.updatedAt).format('DD-MM-YYYY')}`
      logs.push({str: str, sNo:sNo});
      sNo++;
  });

    // console.log('logs is ',logs)
    setDisplayData(logs)
    // console.log(logs)
  }

  const csvDownloadHandler = async () => {
    setLoading(true);
    try {
        downloadExcel();
    } catch (error) {
        console.log("error", error);
        props?.setSnackInfo(
            error?.response?.data?.message ?? "Something went wrong",
            "error"
        );
    }
    setLoading(false);
  };
  const downloadExcel = () => {
      setLoading(true);
      try {
          setTimeout(() => {
              csvButtonRef.current.link.click();
          });
      } catch (err) {
          console.error(err.message);
      }
      setLoading(false);
  };


  useEffect(()=>{
    getDataOnPageLoading();
  },[reRender,page,rowsPerPage])

  // console.log('displayData in displaypage is ',displayData)
  return (
    <>
      {/* <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
              style={{margin:"15px"}}
            >
              <Grid md={2}>
                <TextField
                  id="date"
                  name="startDate"
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  className={classes.textField}
                />
              </Grid>
              <Grid md={2}>
                <TextField
                  id="date"
                  name="endDate"
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  className={classes.textField}
                />
              </Grid>
              <Grid>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!startDate || !endDate}
                  onClick={handleDateFilter}
                  className={classes.submitButton}
                >
                  Submit
                </Button>
              </Grid>

              <Grid>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={clearFilterDate}
                  style={{marginRight:"200px"}}
                  className={classes.clearButton}
                >
                  Clear Filter
                </Button>
              </Grid>
              <Grid></Grid>
      </Grid> */}

      <CSVLink
        headers={headers}
        filename={"userLogs.csv"}
        data={displayData}
        ref={csvButtonRef}
      />
      <Button
        onClick={csvDownloadHandler}
        style={{
          backgroundColor: "#355025",
          color: "#FFF2EB",
          width: "200px",
          margin: '20px'
        }}
        // className={classes.downloadButton}
        variant="contained"
        color="success"
      >
        Download CSV
      </Button>

      <TableContainer component={Paper} style={{ width: '100%' }}>
     
        <Table
          className={classes.table}
          stickyHeader
          aria-label="sticky table"
          style={{ width: '100%' }}
        >
          <TableBody>
            {displayData?.map((data, i) => {
              return (
                <StyledTableRow key={i}>
                  <StyledTableCell component="th" style={{width: "20px"}}>{page*rowsPerPage + i + 1}</StyledTableCell>
                  <StyledTableCell component="th" style={{ textAlign: "left", whiteSpace: "pre-line"}} >
                    {data.str}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
              rowsPerPageOptions={[10,50,100,200, { label: 'All', value: totalRowCount ? totalRowCount : '' }]}
                colSpan={8}
                count={totalRowCount}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
        
      </TableContainer>
    </>

  )
}

export default connect(null, { setLoading, setSnackInfo, setUserDetails })(TeamUserLogs);